import styled from 'styled-components'

export const OrderedList = styled.ol`
	display: flex;
	flex-direction: column;
	row-gap: 6px;
	margin: 0;
	padding: 0;
	list-style: none;
`
